import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';
import {TranslationService} from './translation.service';
import {
    AdminUser,
    ApiResponse,
    Car,
    CarsOnMapResponse,
    CompanySessionsResponse,
    OverviewData
} from '../models/api.models';

@Injectable()

export class DataService {
    dataChangedCars = new EventEmitter<void>();
    dataChangedOverview = new EventEmitter<void>();
    dataChangedOnlineCars = new EventEmitter<void>();
    dataChangedSession = new EventEmitter<void>();
    dataChangedCarsOnMap = new EventEmitter<void>();

    userInfo?: AdminUser;
    sessionIdentifier?: string;
    overviewData?: OverviewData;
    onlineCars?: CompanySessionsResponse;
    cars: Car[] = [];
    currentCarsOnMap?: CarsOnMapResponse;

    constructor(
        private router: Router,
        private translationService: TranslationService
    ) {
    }

    getSessionIdentifier() {
        return this.sessionIdentifier;
    }

    getUserInfo() {
        return this.userInfo;
    }

    setUserInfo(info: AdminUser) {
        this.userInfo = info;
        this.sessionIdentifier = this.userInfo.SessionIdentifier;
        this.translationService.setLanguage(this.userInfo.Language);

        this.dataChangedSession.emit();
    }

    clearSession() {
        this.userInfo = undefined;
        this.sessionIdentifier = undefined;
        this.dataChangedSession.emit();
    }

    getOverviewData() {
        return this.overviewData;
    }

    getCars() {
        return this.cars;
    }

    setOverviewData(newOverviewData: OverviewData) {
        this.overviewData = newOverviewData;
        this.dataChangedOverview.emit();
    }

    getOnlineCars() {
        return this.onlineCars;
    }

    setOnlineCars(newOnlineCars: CompanySessionsResponse) {
        this.onlineCars = newOnlineCars;
        this.dataChangedOnlineCars.emit();
    }

    setCars(newCars: Car[]) {
        this.cars = newCars;
        this.dataChangedCars.emit();
    }

    getCurrentCarsOnMap() {
        return this.currentCarsOnMap;
    }

    setCurrentCarsOnMap(newCarsOnMap: CarsOnMapResponse) {
        this.currentCarsOnMap = newCarsOnMap;
        this.dataChangedCarsOnMap.emit();
    }

    isResponseSuccessful(res: ApiResponse | null | undefined): boolean {
        if (!isNullOrUndefined(res)) {
            if (res.StatusCode === 0) {
                return true;
            }
        }
        return false;
    }

}
